/* eslint-disable */
import { App, ConfigProvider } from "antd";
import { FAQApp } from "./webparts/components/FAQApp";
import { RootStoreProvider } from "./webparts/components/RootStoreProvider";

const FAQAppComponent = () => {
  return (
    <ConfigProvider
      theme={{
        token: {},
        components: {
          Collapse: {
            colorBorder: "none",
            headerBg: "#ffffff",
            paddingSM: 6,
            padding: 0,
          },
          Button: {
            borderRadius: 4,
            colorPrimary: "#5a7890",
            colorPrimaryHover: "rgba(47, 75, 98, 1)",
            colorPrimaryActive: "rgba(47, 75, 98, 1)",
            colorPrimaryTextActive: "#ffffff",
          },
          Typography: {
            fontSize: 16,
          },
        },
      }}
    >
     
        <App>
          <RootStoreProvider>
            <FAQApp />
          </RootStoreProvider>
        </App>
    
    </ConfigProvider>
  );
};

export default FAQAppComponent;